import main from './main';
export const routes = [
  {
    path: '/',
    component: () => import('@/mobile/page/home'),
    redirect: '/login',
    meta: {
      name: 'home',
    },
  },
  {
    path: '/main',
    component: () => import('@/mobile/page/home'),
    redirect: '/main/landing',
    children: [...main],
    meta: {
      name: '메인화면',
    },
  },
  {
    path: '/main/landing',
    component: () => import('@/mobile/page/main'),
    meta: {
      name: '메인화면 랜딩', //실제 메인 화면
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/mobile/page/login'),
    meta: {
      name: '로그인',
    },
  },
  {
    path: '/dashboard/landing',
    component: () => import('@/mobile/page/home'),
    redirect: '/main/landing',
    meta: {
      name: '모바일 전환 랜딩페이지',
    },
  },
];
